import React from "react";

interface RoleProps {
    id: number;
    position_title : string;
    client_name : string;
    matched_skills : number; 
    matched_cert: number;
    matched_percentage : number;
}

interface roleModalProps {
    roles : RoleProps[];
    name : string;
}

const RolesMatched : React.FC<roleModalProps> = ({roles, name}) => {
    return(
        <div className="min-w-[38rem]">
            <div className="my-2 uppercase font-semibold">
               Role/s matched for <i className="text-blue-500">{name}</i>:
            </div>
            <div className="mb-4">
                <p>Matched: {roles.length} result/s</p>
            </div>
            <div className="flex flex-col gap-4 overflow-y-auto max-h-96">
                {roles.length > 0 ? roles.map((role, index) => (
                    <div className="flex gap-4 items-center">
                        <div className="text-2xl font-semibold text-orange-500">
                            {role.matched_percentage}%
                        </div>
                        <div>
                            <div className="flex gap-4">
                                <a href={`/requirements/details/${role.id}/${encodeURIComponent(role.client_name)}/${encodeURIComponent(role.position_title)}`} rel="noopener noreferrer" target="_blank"
                                   className="underline hover:text-blue-500 cursor-pointer"
                                >
                                    {role.position_title}
                                </a>
                            </div>
                            <div className="text-sm flex gap-8">
                                <div className="bg-green-300 px-4 rounded-xl shadow">
                                    <p>Matched skills: {role.matched_skills}</p>
                                </div>
                                <div className="bg-green-300 px-4 rounded-xl shadow">
                                    <p>Matched certificate: {role.matched_cert}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )) : (
                    <div>No requirement matched</div>
                )}
            </div>
        </div>
    )
}

export default RolesMatched;